/* eslint-disable */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import CommonTextField from '../../../Components/TextField/textField';
import CommonDatePicker from '../../../Components/Datepicker/datepicker';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import FormDialog from '../../../Components/Modal/modal';
import './addEditStaffAugmentation.scss';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { AuthContext } from '../../../Contexts/AuthContext';
import UseAxios from '../../../Api/http/http';
import { STAFF_AUGMENTATION } from '../../../Constants/strings';
import {
  addStaffAugmentation,
  updateStaffAugmentation,
} from '../../../Api/request/staffAugmentation';
import SimpleSnackbar from '../../../Components/Snackbar/snackbar';
import useAddEditStaffAugmentation from './useAddEditStaffAugmentation';
import { InputLabel, TextField, Typography, IconButton, FormControlLabel, Checkbox } from '@mui/material';
import {
  fetchVertivalList,
  fetchLostDroppedReasonList,
  fetchGeographyList,
} from '../../Configuration/Filters/filtersUtil';
import AddEditStaffAugFields from './addEditStaffAugFields';
import MultiSelectAutocomplete from '../../../Components/MultiSelectAutocomplete/multiSelectAutocomplete';
import { logError } from '../../../Utils/logger';
import CloseIcon from '@mui/icons-material/Close';
import isEqual from 'lodash.isequal';
import { MODULE_NAMES } from '../../../Constants/modules';
dayjs.extend(customParseFormat);

const AddRequirementDialog = ({
  handleClose,
  modalOpen,
  setRows,
  setListStaffAugData,
  staffData,
  isEdit = false,
  isCopy = false,
  statusOptions,
  setIsEdit,
  setIsCopy,
}) => {
  const {
    data,
    errors,
    openSnackbar,
    snackbar,
    setData,
    setSnackbar,
    setErrors,
    snackbarOpen,
    getSkillsData,
    getFilteredMandatorySkills,
    handleResetData,
    validateForm,
    loadingSalesMembers,
    loadingDeliveryManagers,
    salesMemberOptions,
    deliveryManagerOptions,
    handleSalesMemberChange,
    handleDeliveryManagerChange,
    yesNoOptions,
    dealTypeOptions,
    lostOrDroppedTypeOptions,
    styles,
    handleClosureDateChange,
    handleRaisedDateChange,
    handleAutoFieldChange,
  } = useAddEditStaffAugmentation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { userProfile } = useContext(AuthContext);
  const [verticalList, setVerticalList] = useState([]);
  const [lostStatusList, setLostStatusList] = useState([]);
  const [geographyList, setGeographyList] = useState([]);
  const isFirstLoad = useRef(true); // Tracks if it's the first load
  const isFirstGeographyLoad = useRef(true);
  const fileInputRef = useRef(null);
  const [hasUserSelectedFile, setHasUserSelectedFile] = useState(false);
  const [originalData, setOriginalData] = useState({});
  const originalDataRef = useRef(null);

  useEffect(() => {
    getSkillsData();
    fetchVertivalList().then(setVerticalList);
  }, []);

  useEffect(() => {
    getSkillsData(data?.vertical?.id);
  }, [data?.vertical]);

  // Fetch lostStatusList when lostDroppedType changes
  useEffect(() => {
    if (data.lostDroppedType?.name) {
      fetchLostDroppedReasonList(data.lostDroppedType.name).then((list) => {
        setLostStatusList(list);

        // Set the selected lostDroppedReason based on staffData
        if (isFirstLoad.current && staffData?.lostDroppedDetails?.[0]?.lostDroppedReason) {
          const selectedLostDroppedReason = list.find(
            (option) => option.name === staffData?.lostDroppedDetails[0]?.lostDroppedReason)
            || {
            id: staffData?.lostDroppedDetails?.[0]?.statusId,
            name: staffData?.lostDroppedDetails?.[0]?.lostDroppedReason,
          };

          setData((prev) => ({
            ...prev,
            lostDroppedReason: selectedLostDroppedReason || null,
          }));
          isFirstLoad.current = false;
        }
      });
    }
  }, [data.lostDroppedType, staffData]);


  useEffect(() => {
    if (data.dealType?.name) {
      fetchGeographyList(data.dealType.name).then((list) => {
        setGeographyList(list);

        if (isFirstGeographyLoad.current && staffData?.geographyPlace) {
          const selectedGeography =
            list.find((option) => option.name === staffData?.geographyPlace) || {
              id: staffData?.geographyId,
              name: staffData?.geographyPlace,
            };

          setData((prev) => {
            const updatedData = {
              ...prev,
              geography: selectedGeography || null,
            };

            if (isCopy && !originalDataRef.current) {
              originalDataRef.current = updatedData;
            }

            return updatedData;
          });

          isFirstGeographyLoad.current = false;
        }
      });
    }
  }, [data.dealType, staffData]);


  useEffect(() => {
    updateEditData();
  }, [staffData]);

  const updateEditData = () => {
     if (isCopy) {
      originalDataRef.current = null;
     }
    if (staffData && Object.keys(staffData).length > 0) {
      const status = statusOptions.find((option) => option.name === staffData?.statusName) || staffData?.statusName;
      const vertical = verticalList.find((option) => option.name === staffData?.verticalName);
      const lostDroppedType = lostOrDroppedTypeOptions.find(
        (option) => option.name === staffData?.lostDropperdStatusName);
      const resourceOnboarded = yesNoOptions.find(
        (option) => option.name === (staffData?.isResourceOnboarded ? 'Yes' : 'No'));
      const interviewRequired = yesNoOptions.find(
        (option) => option.name === (staffData?.isInterviewRequired ? 'Yes' : 'No'));
      const jdReceived = isCopy
        ? yesNoOptions.find((option) => option.name === 'No')
        : yesNoOptions.find((option) => option.name === (staffData?.isJdReceived ? 'Yes' : 'No'));
      // Get full skill objects
      const mandatorySkills = getFilteredMandatorySkills()
        .filter(skill => staffData?.mandatorySkills.includes(skill.id));
      const dealType = dealTypeOptions.find(
        (option) => option.name === staffData?.dealType);

      // Handle experience split for cases like "5 years" or "5-10 years"
      let minExperience = '';
      let maxExperience = '';
      if (staffData.experience) {
        const expParts = staffData.experience.split('-');
        if (expParts.length === 2) {
          minExperience = expParts[0]?.trim();
          maxExperience = expParts[1]?.replace(/[^0-9.]/g, '').trim();
        } else {
          // If only one value like "5 years"
          minExperience = staffData.experience.replace(/[^0-9.]/g, '').trim();
          maxExperience = '';
        }
      }

      const clonedData = {
        clientName: staffData.clientName,
        salesMember: staffData?.salesMember,
        deliveryManager: staffData?.deliveryManager,
        vertical: vertical,
        location: staffData.location,
        description: staffData?.comment === '-' ? '- ' : staffData.comment,
        raisedDate: dayjs(staffData.requestedDate),
        mandatoryFields: mandatorySkills,
        optionalFields: staffData.optionalSkills,
        interviewRequired: interviewRequired,
        yearOfExperince: staffData.experience,
        minExperience: minExperience,
        maxExperience: maxExperience,
        duration: staffData.duration,
        lostDroppedType: lostDroppedType,
        jdReceived: jdReceived,
        closureDate: staffData.closureDate ? dayjs(staffData.closureDate) : null,
        resourceOnboarded: resourceOnboarded,
        status: status,
        uploadJd: isCopy ? '' : staffData.jdDetails,
        dealType: dealType || null,
        noOfPositions: staffData.positionCount,
        isTeamVisible: !!staffData?.isTeamVisible,
      };

      setData(clonedData);
      setOriginalData(clonedData);
    }
  };

  const isDataChanged = useMemo(() => {
    return !isEqual(data, originalDataRef.current);
  }, [data]);


  const handleModalClose = () => {
    handleResetData();
    handleClose();
    setIsEdit(false);
    setIsCopy(false);
    isFirstLoad.current = true;
    isFirstGeographyLoad.current = true;
  };

  const createFormDataPayload = () => {
    const formData = new FormData();

    // Add all fields to FormData
    formData.append('clientName', data.clientName);
    formData.append('requestedDate', data.raisedDate ? dayjs(data.raisedDate).format('YYYY-MM-DD') : null);
    formData.append('closureDate', data.closureDate ? dayjs(data.closureDate).format('YYYY-MM-DD') : null);
    formData.append('verticalId', data?.vertical?.id);
    const min = data.minExperience || 0;
    const max = data.maxExperience || '';
    let experience = '';
    if (max) {
      experience = `${min}-${max} years`;
    } else {
      experience = `${min} year${min === '1' ? '' : 's'}`;
    }
    formData.append('experience', experience);
    formData.append('duration', data.duration || null);
    formData.append('isJdReceived', data.jdReceived?.name == 'Yes');
    formData.append('comments', data.description === '- ' ? '' : data.description);
    formData.append('salesMemberId', data.salesMember?.employeeId);
    formData.append('deliveryManagerId', data.deliveryManager?.employeeId);
    formData.append('isResourceOnBoarded', data.resourceOnboarded?.name == 'Yes');
    formData.append('isInterviewRequired', data.interviewRequired?.name == 'Yes');
    formData.append('lostDroppedReasons', data?.lostDroppedReason?.id || null);
    formData.append('mandatorySkills', data.mandatoryFields?.map(skill => skill.id).join(',') || '');
    formData.append('location', data.location);
    formData.append('statusId', data?.status?.id || staffData?.statusId);
    formData.append('lastUpdatedBy', userProfile.user_name);
    formData.append('dealType', data?.dealType?.name || data?.dealType);
    formData.append('geographyId', data?.geography?.id || null);
    formData.append('noOfPositions', data?.noOfPositions);
    formData.append('is_team_visible', data?.isTeamVisible ? 1 : 0);


    // Append staffingId if it exists
    if (staffData?.id) {
      formData.append('staffingId', staffData?.id);
    }

    // update the optionalSkills:
    formData.append(
      'optionalSkills',
      data.optionalFields?.length
        ? data.optionalFields.every(skill => typeof skill === 'object' && skill.name)
          ? data.optionalFields.map(skill => skill.name).join(',')
          : data.optionalFields.join(',')
        : ''
    );


    // Append file if it exists
    if (data?.uploadJd) {
      formData.append('file', data.uploadJd);
    }

    return formData;
  };

  const handleAddStaffAug = async () => {
    try {
      const formData = createFormDataPayload();
      const response = await UseAxios(addStaffAugmentation(formData));
      if (response.status === 201) {
        const newRecord = response.data.data;
        setRows((prevRows) => [newRecord, ...prevRows]);
        setListStaffAugData((prevData) => [newRecord, ...prevData]);
        setSnackbar({
          message: STAFF_AUGMENTATION.STAFF_ADD_SUCCESS_MESSAGE,
          severity: STAFF_AUGMENTATION.SUCCESS_SEVERITY,
          open: true,
        });
        snackbarOpen();
      } else {
        setSnackbar({
          message: STAFF_AUGMENTATION.STAFF_ADD_FAIL_MESSAGE,
          severity: STAFF_AUGMENTATION.ERROR_SEVERITY,
          open: true,
        });
        snackbarOpen();
      }
    } catch (error) {
      logError('Error in handleAddStaffAug:', error);
      setSnackbar({
        message: STAFF_AUGMENTATION.DELETE_ERROR_MESSAGE,
        severity: STAFF_AUGMENTATION.ERROR_SEVERITY,
        open: true,
      });
      snackbarOpen();
    } finally {
      setIsSubmitting(false);
      handleModalClose();
      snackbarOpen();
    }
  };

  const handleUpdateStaffAug = async () => {
    try {
      const formData = createFormDataPayload();
      const response = await UseAxios(
        updateStaffAugmentation(formData),
      );
      if (response.status === 200) {
        const newRecord = response.data.data;
        setRows((prevRows) =>
          prevRows.some((row) => row.id === newRecord.id)
            ? prevRows.map((row) => (row.id === newRecord.id ? newRecord : row))
            : [newRecord, ...prevRows],
        );
        setListStaffAugData((prevData) =>
          prevData.some((rowData) => rowData.id === newRecord.id)
            ? prevData.map((rowData) =>
              rowData.id === newRecord.id ? newRecord : rowData,
            )
            : [newRecord, ...prevData],
        );
        setSnackbar({
          message: STAFF_AUGMENTATION.UPDATE_SUCCESS_MESSAGE,
          severity: STAFF_AUGMENTATION.SUCCESS_SEVERITY,
          open: true,
        });
        snackbarOpen();
      } else {
        setSnackbar({
          message: STAFF_AUGMENTATION.UPDATE_ERROR_MESSAGE,
          severity: STAFF_AUGMENTATION.ERROR_SEVERITY,
          open: true,
        });
        snackbarOpen();
      }
    } catch (error) {
      logError('Error in handleUpdateStaffAug:', error);
      setSnackbar({
        message: STAFF_AUGMENTATION.DELETE_ERROR_MESSAGE,
        severity: STAFF_AUGMENTATION.ERROR_SEVERITY,
        open: true,
      });
      snackbarOpen();
    } finally {
      handleModalClose();
      setIsSubmitting(false);
      snackbarOpen();
    }
  };

  const isValidFileType = (file) => {
    if (!file) return true; // Skip validation if no file

    const validMimeTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];

    return validMimeTypes.includes(file.type);
  };

  const handleUploadFile = (event) => {
    const file = event.target?.files[0];
    const maxFileSize = 512 * 1024 * 1024; // 512 MB

    if (!file) return;

    if (!isValidFileType(file)) {
      setErrors(prev => ({
        ...prev,
        uploadJd: STAFF_AUGMENTATION.FILE_TYPE_ERROR,
      }));
      event.target.value = '';
      setData(prev => ({ ...prev, uploadJd: '' }));
      setHasUserSelectedFile(false);
      return;
    }

    if (file.size > maxFileSize) {
      setErrors(prev => ({
        ...prev,
        uploadJd: STAFF_AUGMENTATION.FILE_SIZE_ERROR,
      }));
      setData(prev => ({ ...prev, uploadJd: '' }));
      setHasUserSelectedFile(false);
      return;
    }

    setData(prev => ({ ...prev, uploadJd: file }));
    setHasUserSelectedFile(true);
    setErrors(prev => {
      const { uploadJd: __, ...rest } = prev;
      return rest;
    });
  };


  const handleRemoveFile = () => {
    setData(prev => ({ ...prev, uploadJd: '' }));
    setHasUserSelectedFile(false);

    setErrors(prev => {
      const { uploadJd: __, ...rest } = prev;
      return rest;
    });

    if (fileInputRef?.current) {
      fileInputRef.current.value = '';
    }
  };


  const handleSubmit = async () => {
    if (validateForm()) {

      // Check file size if a file is uploaded
      if (data?.uploadJd) {
        const maxFileSize = 512 * 1024 * 1024; // 512 MB in bytes
        if (data?.uploadJd.size > maxFileSize) {
          setSnackbar({
            message: 'File size exceeds 512 MB',
            severity: STAFF_AUGMENTATION.ERROR_SEVERITY,
            open: true,
          });
          snackbarOpen();
          return; // Stop submission if file size exceeds the limit
        }
      }

      setIsSubmitting(true);
      if (!isEdit) {
        handleAddStaffAug();
      } else {
        handleUpdateStaffAug();
      }
    }
  };

  const handleFieldChange = (event) => {
    const id = event.target.id;
    setData((prev) => ({ ...prev, [id]: event.target.value }));
    const newErrors = {};

    if (id === 'description') {
      if (event.target.value.length > 250) {
        newErrors[id] = STAFF_AUGMENTATION.DESCRIPTION_LENGTH_ERROR_MESSAGE;
      } else if (
        event.target.value.length < 2 || event.target.value.length > 250
      ) {
        newErrors[id] = STAFF_AUGMENTATION.DESCRIPTION_LINES_ERROR_MESSAGE;
      }
    }
    if (id === 'duration') {
      if (event.target.value <= '0') {
        newErrors[id] = STAFF_AUGMENTATION.DURATION_ZERO_ERROR;
      } else if (!/^\d+$/.test(event.target.value)) {
        newErrors[id] = STAFF_AUGMENTATION.DURATION_CHAR_ERROR;
      }
    }
    if (id === 'noOfPositions') {
      if (event.target.value == '') {
        newErrors[id] = STAFF_AUGMENTATION.NO_OF_POSITIONS_IS_MANDATORY;
      } else if (event.target.value <= '0') {
        newErrors[id] = STAFF_AUGMENTATION.NO_OF_POSITIONS_ZERO_ERROR;
      } else if (!/^\d+$/.test(event.target.value)) {
        newErrors[id] = STAFF_AUGMENTATION.NO_OF_POSITIONS_CHAR_ERROR;
      }
    }


    setErrors((prev) => {
      const rest = { ...prev };
      delete rest[id];
      return { ...rest, ...newErrors };
    });
  };

  const handleMultiSelectChange = (value, id) => {
    setData((prev) => ({ ...prev, [id]: value }));
    const newErrors = {};
    setErrors((prev) => {
      const rest = { ...prev };
      delete rest[id];
      return { ...rest, ...newErrors };
    });
  };

  const getSelectedValue = (name, options) => {
    return options.find(option => option.name === name) || null;
  };

  return (
    <div>
      <FormDialog
        title={
          isCopy
            ? STAFF_AUGMENTATION.CLONE_REQUIREMENT
            : !isEdit
              ? STAFF_AUGMENTATION.ADD_REQUIREMENT
              : STAFF_AUGMENTATION.EDIT_REQUIREMENT
        }
        open={modalOpen}
        handleClose={handleModalClose}
        button1Action={handleModalClose}
        dialogPaperCss="staff-aug-dialog"
        dialogBodycontent={
          <div className="add-requirement-form">
            <div className='first-section'>
              <div className="form-field">
                <CommonTextField
                  label={
                    <span>
                      {
                        STAFF_AUGMENTATION.STAFF_ADD_INPUTS
                          .OPPORTUNITIES_CLIENT_NAME
                      }
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER
                      .ENTER_OPPORTUNITY_NAME
                  }
                  value={data?.clientName || ''}
                  onChange={handleFieldChange}
                  variant="outlined"
                  textCss="requirement-text-field"
                  autoFocus={false}
                  size="small"
                  id="clientName"
                  disabled={false}
                />
                {errors?.clientName && (
                  <div className="staff-aug-error">
                    <small>{errors?.clientName}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-status">
                <SearchDropdown
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.VERTICAL}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  options={verticalList}
                  value={data?.vertical || ''}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  dropdownCss="status-dropdown"
                  onChange={(event) => handleAutoFieldChange('vertical', event)}
                />
                {errors?.vertical && (
                  <div className="staff-aug-error">
                    <small>{errors?.vertical}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-location">
                <CommonTextField
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.LOCATION}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.LOCATION
                  }
                  value={data?.location || ''}
                  onChange={handleFieldChange}
                  variant="outlined"
                  textCss="requirement-location-field"
                  autoFocus={false}
                  size="small"
                  id="location"
                  disabled={false}
                />
                {errors?.location && (
                  <div className="staff-aug-error">
                    <small>{errors?.location}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-skills">
                <MultiSelectAutocomplete
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.SKILLS}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  options={getFilteredMandatorySkills()}
                  freeSolo={false}
                  value={data?.mandatoryFields || []}
                  onChange={(event, newValue) => {
                    handleMultiSelectChange(newValue, 'mandatoryFields');
                  }}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  dropdownCss="mandatory-fields-dropdown"
                  isFilterRequired={false}
                  disabled={!data?.vertical} // Disable if vertical is not selected
                />
                {errors?.mandatoryFields && (
                  <div className="staff-aug-error">
                    <small>{errors?.mandatoryFields}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-skills">
                <MultiSelectAutocomplete
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.ROLES}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  freeSolo={false}
                  value={data?.optionalFields || []}
                  onChange={(event, newValue) => {
                    handleMultiSelectChange(newValue, 'optionalFields');
                  }}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.ENTER_ROLE
                  }
                  dropdownCss="mandatory-fields-dropdown"
                  isOnBlur
                  isFilterRequired={false}
                />
                {errors?.optionalFields && (
                  <div className="staff-aug-error">
                    <small>{errors?.optionalFields}</small>
                  </div>
                )}
              </div>
              <div className="multiple-field-container">
                <div className="employee-field">
                  <InputLabel className="input-label">
                    {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.MIN_EXPERIENCE}
                    <span className="mandatory-star"> *</span>
                  </InputLabel>
                  <TextField
                    placeholder={STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.ENTER}
                    value={data?.minExperience || ''}
                    onChange={handleFieldChange}
                    variant="outlined"
                    className="requirement-location-field custom-input"
                    size="small"
                    id="minExperience"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 1,
                      max: 100,
                      onKeyDown: (event) => {
                        if (['.', ',', '-'].includes(event.key)) {
                          event.preventDefault();
                        }
                      },
                      onWheel: (event) => event.target.blur(),
                    }}
                  />
                </div>
                <div className="employee-field">
                  <InputLabel className="input-label">
                    {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.MAX_EXPERIENCE}
                  </InputLabel>
                  <TextField
                    placeholder={STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.ENTER}
                    value={data?.maxExperience || ''}
                    onChange={handleFieldChange}
                    variant="outlined"
                    className="requirement-location-field custom-input"
                    size="small"
                    id="maxExperience"
                    type="number"
                    fullWidth
                    inputProps={{
                      min: 1,
                      max: 100,
                      onKeyDown: (event) => {
                        if (['.', ',', '-'].includes(event.key)) {
                          event.preventDefault();
                        }
                      },
                      onWheel: (event) => event.target.blur(),
                    }}
                  />
                </div>
              </div>
              {errors?.minExperience && (
                <div className="staff-aug-error">
                  <small>{errors?.minExperience}</small>
                </div>
              )}

              <div className="staff-aug-skills">
                <InputLabel className="input-label">
                  {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.DURATION}
                  <span className="other-field">
                    {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.IN_MONTHS}
                  </span>
                </InputLabel>
                <TextField
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER
                      .ENTER_DURATION
                  }
                  value={data?.duration || ''}
                  onChange={handleFieldChange}
                  variant="outlined"
                  className={'requirement-location-field custom-input '}
                  autoFocus={false}
                  size="small"
                  id="duration"
                  type="number"
                  fullWidth
                  inputProps={{
                    min: 1,
                    max: 100,
                    onKeyDown: (event) => {
                      // Prevent decimal point, comma and zero
                      if (
                        event.key === '.'
                        || event.key === ','
                        || event.key === '-'
                      ) {
                        event.preventDefault();
                      }
                    },
                    onWheel: (event) => event.target.blur(),
                  }}
                />
                {errors?.duration && (
                  <div className="staff-aug-error">
                    <small>{errors?.duration}</small>
                  </div>
                )}
              </div>
              <div className="staff-date-container">
                <CommonDatePicker
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.RAISED_DATE}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  value={data?.raisedDate || null}
                  onChange={handleRaisedDateChange}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.DATE
                  }
                  minDate={dayjs('01-01-2000')}
                  maxDate={dayjs('31-12-2099')}
                  textCss="date-picker"
                />
                {errors?.raisedDate && (
                  <div className="staff-aug-error">
                    <small>{errors?.raisedDate}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-skills">
                <SearchDropdown
                  id="jd"
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.JD_RECEIVED}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  options={yesNoOptions}
                  searchBox={false}
                  value={getSelectedValue(data?.jdReceived?.name, yesNoOptions)}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  onChange={(event) => {
                    setData((prev) => ({
                      ...prev,
                      jdReceived: event.target.value,
                    }));
                    const newErrors = {};
                    setErrors((prev) => {
                      const rest = { ...prev };
                      delete rest['jdReceived'];
                      return { ...rest, ...newErrors };
                    });
                  }}
                />
                {errors?.jdReceived && (
                  <div className="staff-aug-error">
                    <small>{errors?.jdReceived}</small>
                  </div>
                )}
              </div>
              <div>
                <Typography variant="caption" className="upload-file-label">
                  {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.UPLOAD_JD}
                  <span className="other-field">
                    {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.ONLY_FILE}
                  </span>
                </Typography>

                <div className="file-upload-container">
                  <label htmlFor="file-upload" className="file-upload-button">
                    {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.CHOOSE_FILE}
                  </label>
                  <input
                    id="file-upload"
                    type="file"
                    className="file-input-button"
                    accept=".doc,.docx,.pdf"
                    onChange={handleUploadFile}
                    ref={fileInputRef}
                  />

                  {data.uploadJd && (data.uploadJd.name || data.uploadJd.fileName) ? (
                    <div className="uploaded-file-display">
                      <span className="upload-file-name">
                        {data.uploadJd.name || data.uploadJd.fileName}
                      </span>
                      {hasUserSelectedFile && (
                        <IconButton
                          size="small"
                          onClick={handleRemoveFile}
                          aria-label="Remove uploaded file"
                          className="file-cancel-icon"
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      )}
                    </div>
                  ) : (
                    <span className="upload-file-name">No file chosen</span>
                  )}

                </div>

                {errors?.uploadJd && (
                  <div className="staff-aug-error">
                    <small>{errors?.uploadJd}</small>
                  </div>
                )}
              </div>


              <div className="staff-aug-skills">
                <SearchDropdown
                  id="dealType"
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.DEAL_TYPE}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  options={dealTypeOptions}
                  searchBox={false}
                  value={data?.dealType}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  onChange={(event) => {
                    setData((prev) => ({
                      ...prev,
                      dealType: event.target.value,
                      geography: '',
                    }));
                    setGeographyList([]);
                    const newErrors = {};
                    setErrors((prev) => {
                      const rest = { ...prev };
                      delete rest['dealType'];
                      delete rest['geography'];
                      return { ...rest, ...newErrors };
                    });
                  }}
                />
                {errors?.dealType && (
                  <div className="staff-aug-error">
                    <small>{errors?.dealType}</small>
                  </div>
                )}
              </div>
            </div>
            <div className='second-section'>
              <div className="staff-aug-skills">
                <SearchDropdown
                  id="geography"
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.GEOGRAPHY}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  options={geographyList}
                  searchBox={false}
                  value={data?.geography || null}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.GEOGRAPHY
                  }
                  onChange={(event) => {
                    setData((prev) => ({
                      ...prev,
                      geography: event.target.value,
                    }));
                    const newErrors = {};
                    setErrors((prev) => {
                      const rest = { ...prev };
                      delete rest['geography'];
                      return { ...rest, ...newErrors };
                    });
                  }}
                  disabled={!data?.dealType}
                />
                {errors?.geography && (
                  <div className="staff-aug-error">
                    <small>{errors?.geography}</small>
                  </div>
                )}
              </div>
              <AddEditStaffAugFields
                data={data}
                setFieldData={setData}
                errors={errors}
                salesMemberOptions={salesMemberOptions}
                deliveryManagerOptions={deliveryManagerOptions}
                loadingSalesMembers={loadingSalesMembers}
                loadingDeliveryManagers={loadingDeliveryManagers}
                handleSalesMemberChange={handleSalesMemberChange}
                handleDeliveryManagerChange={handleDeliveryManagerChange}
                verticalList={verticalList}
                styles={styles}
                handleFieldChange={handleFieldChange}
                setErrors={setErrors}
                handleAutoFieldChange={handleAutoFieldChange}
              />
              <div className="staff-aug-positions">
                <CommonTextField
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.NO_OF_POSITIONS}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER
                      .NO_OF_POSITIONS
                  }
                  value={data?.noOfPositions || ''}
                  onChange={handleFieldChange}
                  variant="outlined"
                  textCss="positions-text-field"
                  autoFocus={false}
                  size="small"
                  id="noOfPositions"
                  disabled={false}
                />
                {errors?.noOfPositions && (
                  <div className="staff-aug-error">
                    <small>{errors?.noOfPositions}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-skills">
                <SearchDropdown
                  id="onboarded"
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.RESOURCE_ONBOARDED}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  options={yesNoOptions}
                  searchBox={false}
                  value={getSelectedValue(data?.resourceOnboarded?.name, yesNoOptions)}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  onChange={(event) => {
                    setData((prev) => ({
                      ...prev,
                      resourceOnboarded: event.target.value,
                    }));
                    const newErrors = {};
                    setErrors((prev) => {
                      const rest = { ...prev };
                      delete rest['resourceOnboarded'];
                      return { ...rest, ...newErrors };
                    });
                  }}
                />
                {errors?.resourceOnboarded && (
                  <div className="staff-aug-error">
                    <small>{errors?.resourceOnboarded}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-skills">
                <SearchDropdown
                  id="interview"
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.INTERVIEW_REQUIRED}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  options={yesNoOptions}
                  searchBox={false}
                  value={getSelectedValue(data.interviewRequired?.name, yesNoOptions)}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  onChange={(event) => {
                    setData((prev) => ({
                      ...prev,
                      interviewRequired: event.target.value,
                    }));
                    const newErrors = {};
                    setErrors((prev) => {
                      const rest = { ...prev };
                      delete rest['interviewRequired'];
                      return { ...rest, ...newErrors };
                    });
                  }}
                />
                {errors?.interviewRequired && (
                  <div className="staff-aug-error">
                    <small>{errors?.interviewRequired}</small>
                  </div>
                )}
              </div>
              <div className="staff-date-container">
                <CommonDatePicker
                  label={STAFF_AUGMENTATION.STAFF_ADD_INPUTS.CLOSURE_DATE}
                  value={data?.closureDate || null}
                  onChange={handleClosureDateChange}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.DATE
                  }
                  minDate={dayjs('01-01-2000')}
                  maxDate={dayjs('31-12-2099')}
                  textCss="date-picker"
                />
                {errors?.closureDate && (
                  <div className="staff-aug-error">
                    <small>{errors?.closureDate}</small>
                  </div>
                )}
              </div>
              <div className="description-text-field ">
                <CommonTextField
                  label={STAFF_AUGMENTATION.STAFF_ADD_INPUTS.COMMENTS}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER
                      .ENTER_COMMENTS
                  }
                  value={data?.description || ''}
                  onChange={handleFieldChange}
                  variant="outlined"
                  textCss="description-text-field"
                  autoFocus={false}
                  size="small"
                  id="description"
                  disabled={false}
                  multiline={true}
                  rows={2}
                />
                {errors?.description && (
                  <div className="staff-aug-error">
                    <small>{errors?.description}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-status">
                <SearchDropdown
                  label={STAFF_AUGMENTATION.STAFF_ADD_INPUTS.LOST_DROPPED_TYPE}
                  options={lostOrDroppedTypeOptions}
                  searchBox={false}
                  value={data?.lostDroppedType || ''}
                  onChange={(event) => {
                    setData((prev) => ({
                      ...prev,
                      lostDroppedType: event.target.value,
                      lostDroppedReason: '',
                    }));
                    setLostStatusList([]);
                    setErrors(prev => ({ ...prev, lostDroppedReason: '' }));
                  }}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  dropdownCss="status-dropdown"
                  clearIcon
                />
              </div>
              <div className="staff-aug-status">
                <SearchDropdown
                  label={STAFF_AUGMENTATION.STAFF_ADD_INPUTS.REASON}
                  options={lostStatusList}
                  value={data?.lostDroppedReason || ''}
                  onChange={(event) => {
                    setData((prev) => ({
                      ...prev,
                      lostDroppedReason: event.target.value,
                    }));
                    setErrors(prev => ({ ...prev, lostDroppedReason: '' }));
                  }}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  dropdownCss="status-dropdown"
                  disabled={!data?.lostDroppedType}
                />
                {errors?.lostDroppedReason && (
                  <div className="staff-aug-error">
                    <small>{errors?.lostDroppedReason}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-status">
                <SearchDropdown
                  label={
                    <span>
                      {STAFF_AUGMENTATION.STAFF_ADD_INPUTS.CURRENT_STATUS}
                      <span className="mandatory-star"> *</span>
                    </span>
                  }
                  options={statusOptions}
                  value={data?.status || ''}
                  onChange={(event) => {
                    setData((prev) => ({
                      ...prev,
                      status: event.target.value,
                    }));
                    const newErrors = {};
                    setErrors((prev) => {
                      const rest = { ...prev };
                      delete rest['status'];
                      return { ...rest, ...newErrors };
                    });
                  }}
                  placeholder={
                    STAFF_AUGMENTATION.STAFF_ADD_INPUTS_PLACEHOLDER.SELECT
                  }
                  dropdownCss="status-dropdown"
                />
                {errors?.status && (
                  <div className="staff-aug-error">
                    <small>{errors?.status}</small>
                  </div>
                )}
              </div>
              <div className="staff-aug-checkbox">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!data?.isTeamVisible}
                      onChange={(event) => {
                        setData((prev) => ({
                          ...prev,
                          isTeamVisible: event.target.checked,
                        }));
                      }}
                      id="isTeamVisible"
                      color="primary"
                    />
                  }
                  label={STAFF_AUGMENTATION.STAFF_ADD_INPUTS.VISIBLE_TO_ALL_TEAM_MEMBERS}
                />
              </div>

            </div>
          </div>
        }
        button1="Cancel"
        button2={!isEdit ? 'Save' : 'Update'}
        button2Action={handleSubmit}
        cancelButtonId="cancel-add-requirement"
        submitButtonId="submit-add-requirement"
        dialogCss="save-button"
        button2Disabled={isSubmitting || !isDataChanged}
      />
      <SimpleSnackbar
        open={openSnackbar}
        message={snackbar?.message}
        severity={snackbar?.severity}
        alertCss={`skill-snackbar ${snackbar?.severity}`}
      />
    </div>
  );
};

AddRequirementDialog.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  staffData: PropTypes.object,
  isEdit: PropTypes.bool.isRequired,
  isCopy: PropTypes.bool.isRequired,
  statusOptions: PropTypes.array.isRequired,
  setRows: PropTypes.func.isRequired,
  setIsEdit: PropTypes.func.isRequired,
  setListStaffAugData: PropTypes.func.isRequired,
  setIsCopy: PropTypes.func.isRequired,
};
export default AddRequirementDialog;
